import type { RuleGroupType } from 'react-querybuilder';

type EnumKeys<T> = {
  [K in keyof T]: T[K] extends string ? K : never;
}[keyof T];

type EnumLike<T> = {
  [K in EnumKeys<T>]: T[K];
};

export const enumToOptions = <T extends EnumLike<T>>(enumType: T): { name: string; label: string }[] =>
  Object.values(enumType)
    .sort((a: string, b: string) => a.toLowerCase().localeCompare(b.toLowerCase()))
    .map((value: string) => ({ name: value, label: value }));

export const DEFAULT_QUERY: RuleGroupType = {
  combinator: 'and',
  rules: [],
};
